import { FC } from "react";
import { Blocks, BuilderBlock, isEditing } from "@builder.io/sdk-react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { TabPanels } from "@/components/TabPanels";
import { HorizontalTab } from "@/components/HorizontalTab";
import { CategoryTabNavigation } from "@/components/CategoryTabNavigation";

type CategoryTabNavigationBlockProps = {
  tabs: {
    label: string;
    dlt: string;
    dld: string;
    tabContent: BuilderBlock[];
  }[];
  initialActiveTab?: number;
} & BuilderProps;

export const CategoryTabNavigationBlock: FC<
  CategoryTabNavigationBlockProps
> = ({
  tabs,
  initialActiveTab,
  builderBlock,
  builderComponents,
  builderContext,
  builderLinkComponent,
}) => {
  return (
    <HorizontalTab
      tabs={tabs?.map((tab, index) => ({
        label: tab.label,
        dlt: tab.dlt,
        dld: tab.dld,
        tabContent: (
          <Blocks
            key={`${builderBlock?.id}-${index}`}
            parent={builderBlock?.id}
            registeredComponents={builderComponents}
            context={builderContext}
            path={`tabs.${index}.tabContent`}
            blocks={tab.tabContent}
            linkComponent={builderLinkComponent}
          />
        ),
      }))}
      initialActiveTab={initialActiveTab || 0}
    >
      <CategoryTabNavigation tabClickOverride={isEditing()} />
      <TabPanels animation="fadeInUp" />
    </HorizontalTab>
  );
};
